export default {
  title: {
    id: 'address_book_rules_title',
    defaultMessage: 'Specific rules',
  },
  subtitle: {
    id: 'address_book_rules_subtitle',
    defaultMessage:
      'For situations non-managed by these rules, the default address is used.',
  },
  addNewRule: {
    id: 'address_book_rules_add_new_rule',
    defaultMessage: 'Add a new rule',
  },
  modalTitle: {
    id: 'address_book_rules_modal_title',
    defaultMessage: 'New rule',
  },
}
